import { useDashboardWidgetContext } from 'routes/Dashboard/components/WidgetsLayout/context/WidgetContext';
import { useCopyAnchor } from '../helpers/copyAnchor';
import { NestedMenuOptionT } from 'ui/NestedMenu/NestedMenu';

export const useMenuItems = (
    menuItems: NestedMenuOptionT[],
    canEdit: boolean,
    editMode: boolean,
): NestedMenuOptionT[] => {
    const widget = useDashboardWidgetContext();
    const copyAnchor = useCopyAnchor();
    const copyAnchorMenuItem: NestedMenuOptionT = {
        action: 'copyAnchor',
        menuLevel: 0,
        onClick: () => copyAnchor(widget.key),
    };
    if (editMode) {
        return [];
    }
    if (canEdit) {
        return [copyAnchorMenuItem, ...menuItems];
    }
    return [copyAnchorMenuItem];
};
